import { render } from "./Vector.vue?vue&type=template&id=6ca13db1&scoped=true"
import script from "./Vector.vue?vue&type=script&lang=js"
export * from "./Vector.vue?vue&type=script&lang=js"

import "./Vector.vue?vue&type=style&index=0&id=6ca13db1&scoped=true&lang=css"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca13db1"]])

export default __exports__